module.exports = __webpack_public_path__ + "img/top_banner3.f4a72381.png";